import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";

import React from "react";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import _ from "lodash";
import { API_URL } from "../../constants/api";
import { apiPost, apiPut, apiRequest } from "../../utils/api_service";
import { ShowToast, toastType } from "../../utils/toast-service";
import { GetEnableProperty, isGridFormValid } from "../../utils/helper";
import GridTable from "../common/Table/Table";
import ConfirmDialog from "../common/Dailogbox/ConfirmDailog";
import SearchBar from "../common/SearchBar/SearchBar";
import { IoMdCloseCircleOutline } from "react-icons/io";
import SelectWithSearch from "../common/Autocomplete/SelectWithSearch";
import SelectWithAutoSearch from "../common/Autocomplete/SelectWithAutoSearch";
import { validateInput } from "../../utils/validations";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import { SECTIONS } from "../../constants/appConstants";
const empMappingColList = [
  {
    name: "Email",
    key: "EmployeeEmail",
    idField: "EmployeeId",
    type: "Child",
    isRequired: true,
    isVisible: true,
    dataFormat: "Text",
    editConfig: {
      type: "DropDown",
      sourceKey: "employeeMaster",
      updateKey: "EmployeeId",
      sourceOption: "Email",
      title: "Department",
      isEditField: false,
      isAddField: true,
      multiple: false,
      delimiter: "|"
    }
  },
  {
    name: "AzureGroup",
    key: "GroupName",
    idField: "AccessGroupId",
    type: "Child",
    isRequired: false,
    isVisible: true,
    dataFormat: "Text",
    editConfig: {
      type: "DropDown",
      sourceKey: "azureGroupMaster",
      updateKey: "AccessGroupId",
      sourceOption: "GroupName",
      title: "AzureGroup",
      isEditField: false,
      isAddField: false,
      multiple: false,
      delimiter: "|"
    }
  },
  {
    name: "Data Center",
    key: "PropertyName",
    idField: "PropertyId",
    type: "Child",
    isRequired: true,
    isVisible: true,
    dataFormat: "MultiText",
    minTag: 5,
    editConfig: {
      type: "DropDown",
      sourceKey: "propertyMasterData",
      updateKey: "PropertyId",
      sourceOption: "Abbreviation",
      title: "Department",
      isEditField: true,
      isAddField: true,
      multiple: true,
      delimiter: "|"
    }
  },
  {
    name: "Actions",
    key: "EmployeeId",
    renderComponent: "renderActionColumn",
    minWidth: 90
  }
];

export default class ConfigureEmpProperty extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      confirmMessage: null,
      showWarningMessage: false,
      propertyMasterData: [],
      empMappingList: [],
      responseEmp: [],
      isInAddMode: false,
      selectedEditRowId: undefined,
      validationMessage: [],
      updateData: {
        EmployeeEmail: "",
        PropertyName: ""
      },
      empMappingColumns: _.cloneDeep(empMappingColList),
      openAddEditDialog: false,
      jobRoleMaster: [],
      employeeEmailId: null,
      firstName: null,
      lastName: null,
      groupName: null,
      jobRole: null,
      azureGroupMaster: [],
      defaultValueForRole: null,
      defaultAzureGroup: null,
      clearFilterData: false
    };
  }

  componentDidMount() {
    this.getRequiredData();
  }

  /**
   * call for delete record
   * @param {*} cellInfo 
   */
  deleteRecord(cellInfo) {
    this.setState({
      showWarningMessage: true,
      confirmMessage: "Do you want to delete this record ?",
      updateData: cellInfo
    });
  }

  /**
   * get required data from APIs
   */
  getRequiredData = () => {
    apiRequest({ url: API_URL.datacenter.GetEmpPropertyMaster }).then(
      ({ data }) => {
        data.propertyMaster = GetEnableProperty((data.propertyMaster || []), SECTIONS.CONFIGURE_EMPLOYEE_AND_DATA_CENTER, "PropertyId");
        this.setState({
          employeeMaster: data.employeeMaster?.sort((a, b) =>
            a.Email.toLowerCase() > b.Email.toLowerCase() ? 1 : -1
          ),
          propertyMasterData: data.propertyMaster,
          jobRoleMaster: data.jobMaster?.filter(m => {
            if (m.JobRole != null) return m;
          }),
          azureGroupMaster: data.azureGroupMaster
            .filter(m => {
              if (m.GroupName != null) return m;
            })
            ?.sort((a, b) =>
              a.GroupName.toLowerCase() > b.GroupName.toLowerCase() ? 1 : -1
            )
        });
      }
    );

    apiRequest({ url: API_URL.datacenter.GetEmpPropertyList }).then(
      ({ data: empPropertyList }) => {
        this.setState({
          empMappingList: empPropertyList?.sort((a, b) =>
            a.EmployeeEmail.toLowerCase() > b.EmployeeEmail.toLowerCase()
              ? 1
              : -1
          ),
          responseEmp: _.cloneDeep(empPropertyList) || []
        });
      }
    );
  };

  /**
   * Add new record from given parameters
   * @param {*} newParam 
   * @returns 
   */
  addRecord(newParam) {
    if (!newParam) return;
    apiPost({
      url: API_URL.datacenter.addEmpPropertyList,
      postBody: {
        employeeEmail: newParam.EmployeeEmail,
        propertyIds: newParam.PropertyId.replaceAll("|", ",")
      }
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? "Record added successfully."
            : "Record updated successfully.",
          toastType.SUCCESS,
          5000,
          500
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          showWarningMessage: false,
          isInAddMode: false,
          searchInput: null
        });
        this.getRequiredData();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  }

  /**
   * save newly created record
   * @param {*} newParam 
   * @returns 
   */
  saveRecord(newParam) {
    if (!newParam) return;
    apiPut({
      url: API_URL.datacenter.updateEmpPropertyList,
      postBody: {
        employeeEmail: newParam.EmployeeEmail,
        propertyIds: newParam.PropertyId.replaceAll("|", ",")
      }
    }).then(({ data: response }) => {
      if (response.success === true) {
        ShowToast(
          this.state.isInAddMode
            ? "Record added successfully."
            : "Record updated successfully.",
          toastType.SUCCESS,
          5000,
          500
        );

        this.setState({
          updateData: undefined,
          selectedEditRowId: undefined,
          showWarningMessage: false,
          isInAddMode: false,
          searchInput: null
        });
        this.getRequiredData();
      } else {
        ShowToast(response.message, toastType.ERROR, 5000, 5000);
      }
    });
  }

  /**
   * function Join strings with bar
   * @param {*} arr 
   * @returns 
   */
  joinWithBar = (arr = []) => {
    if (!arr.length) return "";

    let str = "";
    for (let i = 0; i < arr.length; i++) {
      str += arr[i] + "|";
    }
    return str.slice(0, -1);
  };

  /**
   * get property Ids
   * @param {*} arr 
   * @returns 
   */
  getPropertyIds = arr => {
    if (!arr.length) return "";
    const { propertyMasterData } = this.state;

    let str = "";
    for (let i = 0; i < arr.length; i++) {
      const obj = propertyMasterData.find(x => x.Abbreviation === arr[i]);
      if (obj) str += obj.PropertyId + "|";
    }
    return str.slice(0, -1);
  };

  /**
   * call on table values change
   * @param {*} value 
   * @param {*} fieldName 
   */
  handleTableEditChange = (value, fieldName) => {
    const { employeeMaster, selectedEditRowId, updateData } = this.state;
    const param = updateData;
    const validationMessage = this.state.validationMessage;

    if (fieldName === "PropertyName") {
      const valueOfDesignation = this.getPropertyIds(value);
      param.PropertyId = valueOfDesignation;
      param[fieldName] = this.joinWithBar(value); //value.join('|');
    } else if (fieldName === "EmployeeEmail") {
      const id = employeeMaster.find(x => x.Email === value).EmployeeId;
      param.EmployeeId = id + "";
      selectedEditRowId.value = id + "";
      param.EmployeeEmail = value;
    } else {
      param[fieldName] = value;
    }

    this.setState({
      updateData: param,
      validationMessage: (validationMessage || []).filter(x => {
        return x.key !== fieldName;
      }),
      selectedEditRowId
    });

    this.forceUpdate();
  };

  /**
   * Add new record
   * @returns 
   */
  AddNewRecord = () => {
    if (this.state.isInAddMode) {
      ShowToast("You can add one row at a time!", toastType.WARNING, 5000, 500);
      return false;
    }
    const empMappingColumns = _.cloneDeep(empMappingColList);
    const rowNew = {
      EmployeeId: 0,
      designationId: null,
      designation: undefined,
      flag: false
    };

    const { reloadTable } = this.state;

    this.setState({
      isInAddMode: true,
      selectedEditRowId: { key: "EmployeeId", value: 0 },
      updateData: rowNew,
      reloadTable: !reloadTable,
      empMappingColumns
    });
  };

  /**
   * cancel add new record/row mode
   */
  cancelAddMode = () => {
    const { reloadTable } = this.state;

    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !reloadTable
    });
  };

  /**
   * Update existing record information
   * @returns 
   */
  saveUpdatedRecord = () => {
    const { updateData, isInAddMode, empMappingList } = this.state;
    if (!this.isValidForm()) {
      return false;
    } else {
      if (isInAddMode) {
        const isPresent = empMappingList.find(
          x => x.EmployeeId + "" === updateData.EmployeeId
        );
        if (isPresent) {
          ShowToast(
            "Employee info is already present. Please update it instead of new add.",
            toastType.ERROR,
            5000,
            500
          );
        } else {
          this.addRecord(updateData);
        }
      } else {
        this.saveRecord(updateData);
      }
    }
  };

  /**
   * FOrm validation
   * @returns 
   */
  isValidForm = () => {
    let IsValid = true;
    const { updateData, empMappingColumns } = this.state;
    empMappingColumns.forEach(ele => {
      isGridFormValid(updateData[ele.key], ele, updateData);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    this.setState({ empMappingColumns }, this.forceUpdate());
    return IsValid;
  };

  /**
   * cancel row open for edit mode
   */
  cancelEditMode = () => {
    const { reloadTable } = this.state;

    this.setState({
      selectedEditRowId: undefined,
      isInAddMode: false,
      updateData: undefined,
      showWarningMessage: false,
      reloadTable: !reloadTable
    });
  };

  /**
   * Edit existing record
   * @param {*} cellInfo 
   */
  EditRecord = cellInfo => {
    const empMappingColumns = _.cloneDeep(empMappingColList);
    const { reloadTable } = this.state;

    this.setState({
      selectedEditRowId: {
        key: "EmployeeId",
        value: cellInfo.EmployeeId
      },
      isInAddMode: false,
      updateData: { ...cellInfo },
      reloadTable: !reloadTable,
      empMappingColumns
    });
  };

  /**
   * Render Action column (add new record/ edit/update record / delete record)
   * @param {*} cellInfo 
   * @param {*} isInAddMode 
   * @returns 
   */
  renderActionColumn = (cellInfo, isInAddMode) => {
    return (
      <>
        {this.state.selectedEditRowId !== undefined &&
        cellInfo.EmployeeId === this.state.selectedEditRowId.value ? (
          <>
            <Tooltip title={"Save Record"}>
              <IconButton
                aria-label={"refreshData"}
                size={"small"}
                onClick={this.saveUpdatedRecord}
              >
                <SaveIcon fontSize={"small"} size={"small"} />
              </IconButton>
            </Tooltip>
            <Tooltip title={"Cancel"}>
              <IconButton
                aria-label={"refreshData"}
                size={"small"}
                onClick={isInAddMode ? this.cancelAddMode : this.cancelEditMode}
              >
                <CancelIcon fontSize={"small"} size={"small"} />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
             
            {true && (
              <Tooltip title={"Edit Record"}>
                <IconButton
                  aria-label={"refreshData"}
                  size={"small"}
                  onClick={() => {
                    if (
                      this.state.isInAddMode === true ||
                      this.state.selectedEditRowId !== undefined
                    ) {
                      ShowToast(
                        "You can add/Edit one row at a time!",
                        toastType.WARNING,
                        5000,
                        500
                      );
                      return false;
                    } else {
                      this.EditRecord(cellInfo);
                    }
                  }}
                >
                  <EditIcon fontSize={"small"} size={"small"} />
                </IconButton>
              </Tooltip>
            )}
           
            <Tooltip title={"Delete"}>
              <IconButton
                aria-label={"refreshData"}
                size={"small"}
                onClick={() => {
                  this.deleteRecord(cellInfo);
                }}
              >
                <DeleteIcon fontSize={"small"} size={"small"} />
              </IconButton>
            </Tooltip>
            
          </>
        )}
      </>
    );
  };

  /**
   * call on delete onclick 
   * @param {*} isDelete 
   */
  onClickHandel(isDelete) {
    const { updateData } = this.state;

    if (isDelete) {
      apiPost({
        url: API_URL.datacenter.deleteEmpPropertyList, //+ "/employeeId=" + updateData.EmployeeEmail,
        postBody: {
          employeeEmail: updateData.EmployeeEmail
        }
      }).then(response => {
        response.success == false
          ? ShowToast(
              "Server Error: Unable to delete Record.",
              toastType.ERROR,
              5000,
              500
            )
          : ShowToast(
              "Record has been deleted successfully.",
              toastType.SUCCESS,
              5000,
              200
            );
        this.setState({ showWarningMessage: false, searchInput: null }, () => {
          this.getRequiredData();
        });
      });
    } else {
      this.setState({ showWarningMessage: false });
    }
  }

  /**
   * Call on handle change
   * @param {*} event 
   */
  handleChange = event => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch();
    });
  };

  /**
   * Global search
   */
  globalSearch = () => {
    const { searchInput } = this.state;
    const searchData = this.state.responseEmp;
    const filteredData = searchData.filter(value => {
      return value.EmployeeEmail
        ? value.EmployeeEmail.toString()
            .toLowerCase()
            .includes(searchInput.toLowerCase())
        : false;
      // }
    });
    this.setState({
      empMappingList: filteredData?.sort((a, b) =>
        a.EmployeeEmail.toLowerCase() > b.EmployeeEmail.toLowerCase() ? 1 : -1
      )
    });
  };

  /**
   * Call on add edit click to open dialog
   */
  addEditEmployee = () => {
    this.setState({ openAddEditDialog: true });
  };

  /**
   * call on chaNge state
   * @param {*} key 
   * @param {*} value 
   */
  changeState = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  /**
   * call on change email state as well as fetch user details.
   * @param {*} key 
   * @param {*} value 
   */
  changeEmailStateAndGetUserDetails = (key, value) => {
    const empData = this.state.employeeMaster?.find(x => x.Email == value);
    if (empData && empData) {
      const { azureGroupMaster, reloadSelectedValue } = this.state;
      this.setState({
        employeeEmailId: empData.Email,
        firstName: empData.FirstName,
        lastName: empData.LastName,
        jobRole: empData.JobRole,
        groupName: azureGroupMaster.find(
          x => x.AccessGroupId == empData.AccessGroupId
        )?.GroupName,
        reloadSelectedValue: reloadSelectedValue,
        defaultAzureGroup: {
          AccessGroupId: empData.AccessGroupId,
          GroupName: azureGroupMaster.find(
            x => x.AccessGroupId == empData.AccessGroupId
          )?.GroupName
        },
        defaultValueForRole: { JobId: empData.JobId, JobRole: empData.JobRole }
      });
    } else {
      this.setState({
        [key]: value
      });
    }
  };

  /**
   * call on input value change
   * @param {*} key 
   * @param {*} value 
   */
  onInputChange = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  /**
   * handle input change
   * @param {*} e 
   */
  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  /**
   * Update employee
   */
  addUpdateEmployee() {
    const employeeRequest = {
      employeeEmail: this.state.employeeEmailId,
      jobId: this.state.jobRoleMaster?.find(
        x => x.JobRole == this.state.jobRole
      )?.JobId,
      JobRole: this.state.jobRole,
      accessGroupId: this.state.azureGroupMaster?.find(
        x => x.GroupName == this.state.groupName
      )?.AccessGroupId,
      firstName: this.state.firstName,
      lastName: this.state.lastName
    };

    const employeeValidation = [
      {
        valueKey: "lastName",
        type: "text",
        isRequired: true,
        fieldsName: "Last Name"
      },
      {
        valueKey: "firstName",
        type: "text",
        isRequired: true,
        fieldsName: "Last Name"
      },
      {
        valueKey: "employeeEmail",
        type: "email",
        isRequired: true,
        fieldsName: "Employee Email"
      }
    ];
    if (validateInput(employeeRequest, employeeValidation)) {
      apiPost({
        url: API_URL.datacenter.addUpdateEmployee,
        postBody: employeeRequest
        // {
        //   employeeEmail: this.state.employeeEmailId,
        //   jobId: this.state.jobRoleMaster?.find(
        //     (x) => x.JobRole == this.state.jobRole
        //   )?.JobId,
        //   JobRole:this.state.jobRole,
        //   accessGroupId: this.state.azureGroupMaster?.find(
        //     (x) => x.GroupName == this.state.groupName
        //   )?.AccessGroupId,
        //   firstName:this.state.firstName,
        //   lastName:this.state.lastName

        // }
      }).then(({ data: response }) => {
        if (response.success === true) {
          response.data.RecordStatus == 1
            ? ShowToast(
                "Record added successfully.",
                toastType.SUCCESS,
                5000,
                500
              )
            : ShowToast(
                "Record updated successfully.",
                toastType.SUCCESS,
                5000,
                500
              );
          const { clearFilterData } = this.state;
          this.setState({
            clearFilterData: !clearFilterData,
            defaultAzureGroup: null,
            defaultValueForRole: null,
            openAddEditDialog: false,
            employeeEmailId: null,
            jobRole: null,
            groupName: null,
            firstName: null,
            lastName: null,
            searchInput: null
          });

          this.getRequiredData();
        } else {
          ShowToast(response.message, toastType.ERROR, 5000, 5000);
          const { clearFilterData } = this.state;
          this.setState({
            clearFilterData: !clearFilterData,
            defaultAzureGroup: null,
            defaultValueForRole: null,
            openAddEditDialog: false,
            employeeEmailId: null,
            jobRole: null,
            groupName: null,
            firstName: null,
            lastName: null,
            searchInput: null
          });
        }
      });
    }
  }

  render() {
    const {
      propertyMasterData,
      empMappingColumns,
      employeeMaster,
      clearFilterData,
      azureGroupMaster
    } = this.state;

    const EditSource = [];
    EditSource.push({
      key: "propertyMasterData",
      data: propertyMasterData
    });
    EditSource.push({
      key: "employeeMaster",
      data: employeeMaster
    });
    EditSource.push({
      key: "azureGroupMaster",
      data: azureGroupMaster
    });
    return (
      <>
        {this.state.openAddEditDialog && (
          <Dialog
            className={"head-btn-icon"}
            open={this.state.openAddEditDialog}
            //onClose={() => this.props.onClose(false)}
            // PaperComponent={PaperComponent}
            fullWidth
            maxWidth={"md"}
            // className="addUpdateTenants"
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar className={"head-btn-icon"}>
                <div className={"col-xs-11"}>
                  <Typography
                    variant={"h6"}
                    style={{ marginLeft: "10px", flex: "1" }}
                  >
                    {"Add/Edit Employee\r"}
                  </Typography>
                </div>
                <div className={"col-xs-1 end-xs"}>
                  <Tooltip title={"Close"}>
                    <IconButton
                      title={"Close"}
                      edge={"end"}
                      color={"inherit"}
                      onClick={() => {
                        const { clearFilterData } = this.state;
                        this.setState({
                          clearFilterData: !clearFilterData,
                          defaultAzureGroup: null,
                          defaultValueForRole: null,
                          openAddEditDialog: false,
                          employeeEmailId: null,
                          jobRole: null,
                          groupName: null,
                          firstName: null,
                          lastName: null
                        });
                      }}
                      aria-label={"close"}
                      className={"white-button"}
                    >
                      <IoMdCloseCircleOutline />
                    </IconButton>
                  </Tooltip>
                </div>
              </Toolbar>
            </AppBar>

            <DialogContent>
              <div className={"row"}>
                <div className={"col-xs-4"}>
                  <SelectWithAutoSearch
                    clearFilterData={clearFilterData}
                    onInputValueChange={this.onInputChange}
                    isRequired
                    id={"employeeEmailId"}
                    className={"box-style"}
                    labelHeading={"Email"}
                    optionsList={this.state.employeeMaster}
                    selectedId={this.state.employeeEmailId}
                    keyValue={"employeeEmailId"}
                    keyForMapping={"Email"}
                    onChange={this.changeEmailStateAndGetUserDetails}
                    disabled={false}
                  />
                </div>
                <div className={"col-xs-4"}>
                  <TextFieldWithToolTip
                    boldLabel
                    id={"firstName"}
                    txtName={"firstName"}
                    isRequired
                    labelHeading={"First Name"}
                    value={this.state.firstName || ""}
                    onChange={this.handleInputChange}
                    inProps
                  />
                </div>
                <div className={"col-xs-4"}>
                  <TextFieldWithToolTip
                    boldLabel
                    id={"lastName"}
                    txtName={"lastName"}
                    isRequired
                    labelHeading={"Last Name"}
                    value={this.state.lastName || ""}
                    onChange={this.handleInputChange}
                    inProps
                  />
                </div>
              </div>
              <div className={"row bottom-xs"}>
                <div className={"col-xs-4"}>
                  <SelectWithSearch
                    clearFilterData={clearFilterData}
                    reloadData={this.state.reloadSelectedValue}
                    isRequired={false}
                    defaultValue={this.state.defaultValueForRole}
                    id={"Country"}
                    className={"box-style"}
                    labelHeading={"Job Role"}
                    optionsList={this.state.jobRoleMaster}
                    selectedId={this.state.jobRole}
                    keyValue={"jobRole"}
                    keyForMapping={"JobRole"}
                    onChange={this.changeState}
                    disabled={false}
                  />
                </div>
                <div className={"col-xs-4"}>
                  <SelectWithSearch
                    clearFilterData={clearFilterData}
                    reloadData={this.state.reloadSelectedValue}
                    isRequired={false}
                    defaultValue={this.state.defaultAzureGroup}
                    id={"azureGrp"}
                    className={"box-style"}
                    labelHeading={"Azure Group"}
                    optionsList={this.state.azureGroupMaster}
                    selectedId={this.state.groupName}
                    keyValue={"groupName"}
                    keyForMapping={"GroupName"}
                    onChange={this.changeState}
                    disabled={false}
                  />
                </div>
              </div>

              {/* </Box> */}
            </DialogContent>
            <DialogActions style={{ paddingRight: "24px" }}>
              <Button
                autoFocus
                color={"primary"}
                onClick={() => {
                  const { clearFilterData } = this.state;
                  this.setState({
                    clearFilterData: !clearFilterData,
                    defaultAzureGroup: null,
                    defaultValueForRole: null,
                    openAddEditDialog: false,
                    employeeEmailId: null,
                    jobRole: null,
                    groupName: null,
                    firstName: null,
                    lastName: null
                  });
                }}
              >
                {"Cancel\r"}
              </Button>
              <Button
                style={{ marginRight: "8px" }}
                autoFocus
                color={"primary"}
                onClick={() => this.addUpdateEmployee()}
              >
                {"Submit\r"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {this.state.showWarningMessage && (
          <ConfirmDialog
            IsOpen={this.state.showWarningMessage}
            Message={this.state.confirmMessage}
            OnHandelClick={isValid => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText={"Yes"}
            DisAgreeText={"No"}
          />
        )}

        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                colSpan={2}
              >
                <div className={"content-header d-flex"}>
                  {" "}
                  <div
                    className={"col-xs-11"}
                    style={{ display: "inline-block", alignItems: "center" }}
                  >
                    {"Employee and Data Center Configuration\r"}
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ padding: "6px" }}>
                <div className={"col-sm-4 col-md-4 col-lg-4"}>
                  <SearchBar
                    size={"large"}
                    name={"searchInput"}
                    value={this.state.searchInput || ""}
                    onChange={this.handleChange}
                    label={"Search"}
                    placeholder={"Search By Email Id."}
                  />
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <GridTable
                  validationMessage={this.state.validationMessage || []}
                  columns={empMappingColumns}
                  data={this.state.empMappingList}
                  isInline
                  config={empMappingColumns}
                  renderActionColumn={this.renderActionColumn}
                  selectedEditRowId={this.state.selectedEditRowId}
                  isInAddMode={this.state.isInAddMode}
                  EditSource={EditSource}
                  handleTableEditChange={this.handleTableEditChange}
                  updateData={this.state.updateData}
                  AddNewRecord={{
                    action: this.AddNewRecord,
                    title: "Add New Mapping",
                    visible: true
                  }}
                  reload={this.state.reloadTable}
                  additionalAction={{
                    action: this.addEditEmployee,
                    title: "Add/Edit Employee",
                    visible: true
                    // IsSectionVisible(
                    //   SECTIONS.,
                    //   SECTIONS.,
                    //   SECTIONS.ADD_EDIT
                    // ),
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}
